import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/faqs';
import SectionHeading from '@/components/base/SectionHeading';

export default function FaqPreview() {
  const [open, setOpen] = useState(0);
  const preview = faqs.slice(0, 4);

  return (
    <section className="bg-background-100 border-b border-background-200">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <SectionHeading
          eyebrow="FAQ"
          title="常见问题"
          desc="关于信源、核实与投稿方式，这里集中回答。"
          action={
            <Link to="/faq" className="inline-flex items-center gap-1 text-sm text-primary-700 hover:text-primary-800 cursor-pointer whitespace-nowrap">
              全部问题
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        <div className="grid lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8">
            <ul className="space-y-3">
              {preview.map((f, i) => (
                <li key={f.q} className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
                  <button
                    type="button"
                    onClick={() => setOpen(open === i ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                    aria-expanded={open === i}
                  >
                    <span className="font-heading font-bold text-sm md:text-base text-foreground-950">{f.q}</span>
                    <i className={open === i ? 'ri-subtract-line text-primary-600 text-lg' : 'ri-add-line text-foreground-400 text-lg'}></i>
                  </button>
                  {open === i && (
                    <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed border-t border-background-100 pt-4">
                      {f.a}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-accent-200 bg-accent-50 p-6 h-full flex flex-col">
              <span className="w-11 h-11 rounded-md bg-accent-600 text-background-50 flex items-center justify-center mb-4">
                <i className="ri-question-answer-line text-xl"></i>
              </span>
              <h3 className="font-heading font-bold text-lg text-foreground-950">还有别的问题？</h3>
              <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">
                没找到答案，可以直接写邮件，或者用投稿入口留言，编辑会挑高频问题补进这里。
              </p>
              <Link
                to="/contact"
                className="mt-6 inline-flex items-center justify-center gap-2 h-11 px-5 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                联系我们
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}